<dialog 
#preview
dialogBackdrop>
  <div class="container">
    <i 
    class="bi bi-x-lg"
    (click)="dismiss()"
    ></i>
    <img [src]="image()" alt="">
  </div>
</dialog>